module.exports = __webpack_public_path__ + "img/foto-estagio-2.83547d68.png";